// extracted by mini-css-extract-plugin
export default {"container":"SearchModeSelector-module__container__P1wpo"};